import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MoreInfoModalComponent } from 'src/app/shared/more-info-modal/more-info-modal.component';
import { EvaluatorActionsService } from '../../shared/services/evaluator-actions.service';
import { ApiService } from 'src/app/core/services/api-service';

@Component({
  selector: 'app-evaluator-return-modal',
  templateUrl: './evaluator-return-modal.component.html',
  styleUrls: ['./evaluator-return-modal.component.scss']
})
export class EvaluatorReturnModalComponent implements OnInit {
  public remarks = new FormControl()
  courtClearanceType
  public files: File[] = []
  isLoading: boolean = false
  returnType

  constructor(
    public dialogRef: MatDialogRef<EvaluatorReturnModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data,
    private evaluatorActions: EvaluatorActionsService,
    private api: ApiService,
  ) { }

  ngOnInit(): void {
  }

  onSelect(event) {
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  handleSubmit() {
    this.isLoading = true
    this.fileUpload().subscribe(res => {
      this.isLoading = false
      this.dialogRef.close()
    })
  }

  fileUpload() {
    const formData: FormData = new FormData();
    formData.append("EvalStatus", "2");
    formData.append("ReasonForChange", this.remarks.value);
    formData.append("NonCompliantType", this.data.evaluator.displayRole == 'BCPO Access' ? '1' : '0')
    formData.append("CourtClearanceNumber", "");
    formData.append("PoliceClearanceType", "");
    formData.append("BcpoReturnType", this.courtClearanceType ? this.courtClearanceType : 0)

    this.files.forEach((file, index) => {
      formData.append("Files", file, file.name);
    });

    const url = `/evaluator/update-status/${this.data.application.id}`;

    return this.api.put(url, formData);
  }

}
